import { parseRiskList, type RiskLogData } from "./risk-log-model";

import { api } from "@/lib/api";


export async function loadProjectRiskLog(projectId: string): Promise<RiskLogData> {
  const payload: unknown = await api.get(`/projects/${projectId}/risks`);
  return parseRiskList(payload);
}

export async function closeProjectRisk(
  projectId: string,
  riskId: string,
  reason: string,
): Promise<void> {
  await api.post(`/projects/${projectId}/risks/${riskId}/close`, { reason });
}

export async function reopenProjectRisk(
  projectId: string,
  riskId: string,
  reason: string,
): Promise<void> {
  await api.post(`/projects/${projectId}/risks/${riskId}/reopen`, { reason });
}
